
function BookingItemMonth({ booking, count }) {
  if (booking) {
    const displayText = booking.name || booking.customerName || '';
    return (
      <div className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded text-left font-medium truncate">
        <span className="block font-semibold">{displayText}</span>
      </div>
    );
  }
  // fallback for count display (legacy usage)
  return (
    <div className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full text-center font-medium">
      {count} {count === 1 ? 'booking' : 'bookings'}
    </div>
  );
}

export default BookingItemMonth;
